import { render } from "./SpecificationFacets.vue?vue&type=template&id=7c4d37cf"
import script from "./SpecificationFacets.vue?vue&type=script&lang=js"
export * from "./SpecificationFacets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__